module.exports = __webpack_public_path__ + "static/media/equipment.5c2c916b.svg";